import axios from 'axios';
import config from '../config';
import awsExports from '../aws-exports';

class ServersService {
  constructor(options) {
    this.config = config;
    this.options = options;
    this.url = config.url;
    this.svcUrl = config.svcUrl;
    this.svcUrl2 = config.svcUrl2;
    this.apiUrl = config.apiUrl;
    this.awsConfig = awsExports[process.env.VUE_APP_MODE];
    this.userSub = localStorage.getItem(`CognitoIdentityServiceProvider.${this.awsConfig.aws_user_pools_web_client_id}.LastAuthUser`);
    this.latestTokenKey = `CognitoIdentityServiceProvider.${this.awsConfig.aws_user_pools_web_client_id}.${this.userSub}.accessToken`;
   }

  async getServersStatus() {
    return axios.get(`${this.url}serverstatus`);
  }

  async sendCommand(command) {
    return axios.post(`${this.url}servercommand`, command);
  }

  async restartApplication(command) {
    return axios.post(`${this.url}WowzaStreamTarget`, command);
  }
  async getOutputsStatus(data) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(this.latestTokenKey),
      'Client-Id': this.awsConfig.aws_user_pools_web_client_id,

    };

    // axios.post('https://your-api-url.com/endpoint', data, { headers })
    return axios.post(`${this.svcUrl}serverStatus`, data, { headers });
  }

  async getStreamManagerConnections(ids) {
    if (!ids || !ids.length) return
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(this.latestTokenKey),
      'Client-Id': this.awsConfig.aws_user_pools_web_client_id,

    };
    const body = {
      interfaces: [...new Set(ids)]
    }

    // axios.post('https://your-api-url.com/endpoint', data, { headers })
    return axios.post(`${this.svcUrl2}streammanager/connections`, body, { headers });
  }
  async getInputsStatus(data) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(this.latestTokenKey),
      'Client-Id': this.awsConfig.aws_user_pools_web_client_id,

    };

    // axios.post('https://your-api-url.com/endpoint', data, { headers })
    return axios.post(`${this.svcUrl}thumbs`, data, { headers });
  }
  async getInputsStatusThumbs(data) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(this.latestTokenKey),
      'Client-Id': this.awsConfig.aws_user_pools_web_client_id,

    };

    // axios.post('https://your-api-url.com/endpoint', data, { headers })
    return axios.post(`${this.svcUrl}inputsStatus`, data, { headers });
  }
  async getInputsThumb(taskName) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(this.latestTokenKey),
      'Client-Id': this.awsConfig.aws_user_pools_web_client_id,

    };

    // axios.post('https://your-api-url.com/endpoint', data, { headers })
    return axios.get(`${this.svcUrl}thumb?taskName=${taskName}`, { headers });
  }

  async getInputThumbs(data) {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem(this.latestTokenKey),
      'client-id': this.awsConfig.aws_user_pools_web_client_id,
    };

    // Batch thumbnails endpoint as per requirements
    return axios.post(`${this.svcUrl}inputThumbs`, data, { headers });
  }
}

export default new ServersService();
